import { PsNotificationStates } from '../../PsNotificationStates';

export class NotificationExportRequest {

    _page; // number
    _term; // string
    _limit; // number
    _state; // NotificationStates
    _listeria_date_from; // date
    _listeria_date_to; // date
    _date_from; // date
    _date_to; // date

    constructor(limit = 100) {
        this._page = 1;
        this._term = '';
        this._limit = limit;
        this._state = PsNotificationStates.ALL;
        this._listeria_date_from = '';
        this._listeria_date_to = '';
        this._date_from = '';
        this._date_to = '';
    }

    setPage(page) {
        this._page = page;
    }

    setTerm(term) {
        this._term = term;
    }

    setState(state) {
        this._state = state;
    }

    setListeriaDateFrom(date) {
        this._listeria_date_from = date;
    }

    setListeriaDateTo(date) {
        this._listeria_date_to = date;
    }

    setDateFrom(date) {
        this._date_from = date;
    }

    setDateTo(date) {
        this._date_to = date;
    }

    body() {
        return {
            criteria: {
                page: this._page,
                term: this._term,
                limit: this._limit,
                show_only_solved: this._state === PsNotificationStates.SOLVED,
                show_only_unsolved: this._state === PsNotificationStates.NO_SOLVED,
                listeria_date_from: this._listeria_date_from ,
                listeria_date_to: this._listeria_date_to ,
                date_from: this._date_from ,
                date_to: this._date_to ,
            },
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/shared/notificationExport/NotificationExportRequest.js